module.exports = __webpack_public_path__ + "static/theworkout-2-8c85d3618e2b6015aa0eb4982239f19a.jpg";